import { render, staticRenderFns } from "./BaseFiltroRelatorio.vue?vue&type=template&id=f198d9ae"
import script from "./BaseFiltroRelatorio.vue?vue&type=script&lang=js"
export * from "./BaseFiltroRelatorio.vue?vue&type=script&lang=js"
import style0 from "./BaseFiltroRelatorio.vue?vue&type=style&index=0&id=f198d9ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports